module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/clients"
    }
  }, [_vm._v("Applications")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$route.params.client_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.client.name))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$route.params.client_id) + "/articles")
    }
  }, [_vm._v("Articles")])], 1), _vm._v(" "), (_vm.update == true) ? [_c('li', [_c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$route.params.client_id) + "/articles/" + (this.$route.params.article_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.article.title))])], 1), _vm._v(" "), _vm._m(0)] : _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Create a new article")])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.title),
      expression: "fields.title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:100'),
      expression: "'required|max:100'"
    }],
    class: {
      'input': true, 'is-danger': _vm.veeErrors.has('title')
    },
    attrs: {
      "name": "title",
      "type": "text",
      "placeholder": "New article title",
      "data-vv-as": "Article title"
    },
    domProps: {
      "value": (_vm.fields.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fields, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('title')),
      expression: "veeErrors.has('title')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('title')))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Location")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    class: {
      'select': true, 'is-danger': _vm.veeErrors.has('location')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.location),
      expression: "fields.location"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "location",
      "data-vv-as": "Location"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.fields, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "default"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "slider"
    }
  }, [_vm._v("Slider")])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('location')),
      expression: "veeErrors.has('location')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('location')))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    class: {
      'select': true, 'is-danger': _vm.veeErrors.has('articleType')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.articleType),
      expression: "articleType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|in:link,content'),
      expression: "'required|in:link,content'"
    }],
    attrs: {
      "name": "articleType",
      "data-vv-as": "Article type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.articleType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select article type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "link"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "content"
    }
  }, [_vm._v("Content")])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('articleType')),
      expression: "veeErrors.has('articleType')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('articleType')))])]), _vm._v(" "), (_vm.articleType == 'link') ? _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Link")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.link),
      expression: "fields.link"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|url'),
      expression: "'required|url'"
    }],
    class: {
      'input': true, 'is-danger': _vm.veeErrors.has('link')
    },
    attrs: {
      "name": "link",
      "type": "text",
      "placeholder": "URL",
      "data-vv-as": "Link"
    },
    domProps: {
      "value": (_vm.fields.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fields, "link", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('link')),
      expression: "veeErrors.has('link')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('link')))])]) : _vm._e(), _vm._v(" "), (_vm.articleType == 'content') ? _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Content")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.content),
      expression: "fields.content"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'textarea': true, 'is-danger': _vm.veeErrors.has('content')
    },
    attrs: {
      "name": "content",
      "type": "text",
      "placeholder": "Some content here",
      "data-vv-as": "Content"
    },
    domProps: {
      "value": (_vm.fields.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fields, "content", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('content')),
      expression: "veeErrors.has('content')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('content')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Cover")]), _vm._v(" "), _c('div', {
    staticClass: "file"
  }, [_c('label', {
    staticClass: "file-label"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.fields.cover,
        image: true,
        ext: 'jpg'
      }),
      expression: "{ required: !fields.cover, image: true, ext: 'jpg' }"
    }],
    class: {
      'file-input': true, 'is-danger': _vm.veeErrors.has('file1')
    },
    attrs: {
      "name": "file1",
      "type": "file",
      "data-vv-as": "Cover file"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "file-cta"
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "file-label"
  }, [_vm._v(_vm._s(_vm.filename))])])])]), _vm._v(" "), _c('p', {
    staticClass: "help"
  }, [_vm._v("Must be an image file with .jpg extension.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('file1')),
      expression: "veeErrors.has('file1')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('file1')))])]), _vm._v(" "), _c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    class: {
      'button': true, 'is-primary': true, 'is-loading': _vm.isLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": _vm.cancelUrl,
      "exact": ""
    }
  }, [_vm._v("Cancel")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Edit article")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "file-icon"
  }, [_c('i', {
    staticClass: "fa fa-upload"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ae69796"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Articles/ArticleForm.vue
// module id = 333
// module chunks = 1